import type { CSSProperties } from "react";

export const SIDEBAR_MENU_WIDTH = 256;
export const SIDEBAR_MENU_COLLAPSED_WIDTH = 60;
export const CONTENT_MAX_WIDTH = 1920 - SIDEBAR_MENU_WIDTH;

/** À combiner avec `mx-auto max-w-(--maxWidth)` sur le bloc de contenu de la page. */
export const CONTENT_MAX_WIDTH_STYLE: CSSProperties &
  Record<"--maxWidth", string> = {
  "--maxWidth": `${CONTENT_MAX_WIDTH}px`,
};
